import { Typography } from '~/shared/components';
import type { ReservationStoreBase } from '~/features/product-details/components/ReservationDrawer/types';
import styles from '~/features/product-details/components/ReservationDrawer/ReservationStoreList/ReservationStoreList.module.scss';

export const StoreAddress = ({ store }: { store: ReservationStoreBase }) => (
    <div className={styles.storeAddress}>
        <Typography variant="paragraph-S">{store.address1 || ''}</Typography>
        {store.address2 && <Typography variant="paragraph-S">{store.address2}</Typography>}
        <Typography variant="paragraph-S">
            {store.postalCode} {store.city || ''}
        </Typography>
    </div>
);
